import ReactGA from 'react-ga';

const trackingId = "G-8D92ZVS4F2";
ReactGA.initialize(trackingId);

export const trackPageView = (page) => {
  ReactGA.set({ page });
  ReactGA.pageview(page);
};
